import React from 'react'
import PropTypes from 'prop-types'
import { Form, Button } from 'antd'
import AddAndEditPhoneNumberModal from './AddAndEditPhoneNumberModal'
import RemindersEmailAddressEntry from './RemindersEmailAddressEntry'
import ForwardingInfo from './ForwardingInfo'
import DoctorSelect from './DoctorSelect'
import ExistingPhoneNumbers from './ExistingPhoneNumbers'
import css from './contact-mapping.css'

const ContactMapping = ({
  additionalRecipients,
  businesses,
  selectedBusinessId,
  handleSelectedBusiness,
  doctorId,
  doctors,
  fEmails,
  isInvalid,
  isTopsAdmin,
  locations,
  locationId,
  locationCountryCode,
  phoneNumberModal: {
    open: phoneNumberModalOpen,
    action: phoneNumberModalAction,
  },
  officeEmail,
  officePhone,
  onAdditionalRecipientsChange,
  onDoctorSelect,
  onInputChange,
  onSelect,
  pms,
  purchasedNumbers,
  refetchLocations,
  requiresPhoneNumberPurchase,
  showDoctorSelect,
  showAdditionalRecipients,
  smseUsers,
  toggleModal,
  validationError,
}) => {
  const showManualPhoneNumberEntry =
    !isTopsAdmin && locationCountryCode !== 'NZ'
  const showEditButton = locationCountryCode !== 'NZ'

  return (
    <Form className={css.wrapper}>
      <div className={css.remindersContactInfo}>
        <ExistingPhoneNumbers
          locationCountryCode={locationCountryCode}
          purchasedNumbers={purchasedNumbers}
          requiresPhoneNumberPurchase={requiresPhoneNumberPurchase}
          smseUsers={smseUsers}
          toggleModal={toggleModal}
          showEditButton={showEditButton}
        />
        <RemindersEmailAddressEntry
          fEmails={fEmails}
          isInvalid={isInvalid}
          isTopsAdmin={isTopsAdmin}
          onInputChange={onInputChange}
          onSelect={onSelect}
          validationError={validationError}
        />
        {showEditButton && (
          <div className={css.phoneOrEmailWrapper}>
            {showManualPhoneNumberEntry && (
              <Button onClick={() => toggleModal(true, 'add')}>
                Manually Add Phone Number
              </Button>
            )}
            <AddAndEditPhoneNumberModal
              action={phoneNumberModalAction}
              businesses={businesses}
              selectedBusinessId={selectedBusinessId}
              handleSelectedBusiness={handleSelectedBusiness}
              countryCode={locationCountryCode}
              open={phoneNumberModalOpen}
              locations={locations}
              locationId={locationId}
              purchasedNumbers={purchasedNumbers}
              refetchLocations={refetchLocations}
              toggleModal={toggleModal}
            />
          </div>
        )}
        {showDoctorSelect && (
          <DoctorSelect
            doctors={doctors}
            doctorId={doctorId}
            isOpenDental={pms === 'OpenDental'}
            onDoctorSelect={onDoctorSelect}
          />
        )}
      </div>
      <div className={css.forwardTo}>forward to</div>
      <ForwardingInfo
        additionalRecipients={additionalRecipients}
        locationCountryCode={locationCountryCode}
        officeEmail={officeEmail}
        officePhone={officePhone}
        onAdditionalRecipientsChange={onAdditionalRecipientsChange}
        onInputChange={onInputChange}
        requiresPhoneNumberPurchase={requiresPhoneNumberPurchase}
        showAdditionalRecipients={showAdditionalRecipients}
      />
    </Form>
  )
}

ContactMapping.propTypes = {
  businesses: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedBusinessId: PropTypes.number,
  handleSelectedBusiness: PropTypes.func.isRequired,
  doctorId: PropTypes.string,
  doctors: PropTypes.arrayOf(PropTypes.object).isRequired,
  fEmails: PropTypes.arrayOf(PropTypes.string).isRequired,
  isInvalid: PropTypes.bool.isRequired,
  isTopsAdmin: PropTypes.bool.isRequired,
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  locationId: PropTypes.string.isRequired,
  locationCountryCode: PropTypes.string.isRequired,
  phoneNumberModal: PropTypes.shape({
    open: PropTypes.bool.isRequired,
    action: PropTypes.string,
  }).isRequired,
  officeEmail: PropTypes.string,
  officePhone: PropTypes.string,
  additionalRecipients: PropTypes.string,
  onDoctorSelect: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onAdditionalRecipientsChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  pms: PropTypes.string.isRequired,
  purchasedNumbers: PropTypes.arrayOf(
    PropTypes.shape({
      phone_number: PropTypes.string.isRequired,
    }),
  ).isRequired,
  refetchLocations: PropTypes.func.isRequired,
  requiresPhoneNumberPurchase: PropTypes.bool.isRequired,
  showDoctorSelect: PropTypes.bool.isRequired,
  showAdditionalRecipients: PropTypes.bool.isRequired,
  validationError: PropTypes.string.isRequired,
  toggleModal: PropTypes.func.isRequired,
  smseUsers: PropTypes.arrayOf(PropTypes.string).isRequired,
}

ContactMapping.defaultProps = {
  doctorId: null,
  officeEmail: '',
  officePhone: '',
  additionalRecipients: '',
  selectedBusinessId: null,
}

export default ContactMapping



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/ContactMapping.js